/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, makeStyles } from "@material-ui/core/";
import React from "react";
import FormInitial from "./formInitial";
import FormSLA from "./formSLA";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		justifyContent: "center",
		[theme.breakpoints.down("sm")]: {
			flexDirection: "column",
			gap: theme.spacing(4),
		},
	},
}));

const SetupInitialization = () => {
	const classes = useStyles();
	return (
		<Grid className={classes.root}>
			<FormInitial />
			<FormSLA />
		</Grid>
	);
};
export default SetupInitialization;
